import styled from 'styled-components/native';

const DialogBody = styled.View`
  flex; 1;
`;

export default DialogBody;

